// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.referralsProgress-module_container__YPZZw {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.referralsProgress-module_header__tMZbB {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.referralsProgress-module_progressTrack__pSBtl {
    align-self: stretch;
    position: relative;
}

.referralsProgress-module_progressFill__h1htH {
    position: absolute;
    top: 0;
    left: 0;
    transition: width 0.3s ease;
}

.referralsProgress-module_dot__uTclR {
    position: relative;
    z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Bars/referralsProgress.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd","sourcesContent":[".container {\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.progressTrack {\n    align-self: stretch;\n    position: relative;\n}\n\n.progressFill {\n    position: absolute;\n    top: 0;\n    left: 0;\n    transition: width 0.3s ease;\n}\n\n.dot {\n    position: relative;\n    z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `referralsProgress-module_container__YPZZw`,
	"header": `referralsProgress-module_header__tMZbB`,
	"progressTrack": `referralsProgress-module_progressTrack__pSBtl`,
	"progressFill": `referralsProgress-module_progressFill__h1htH`,
	"dot": `referralsProgress-module_dot__uTclR`
};
export default ___CSS_LOADER_EXPORT___;
